export default {

  // Dni y nombres obtenidos de la 2da Api del Login
  actualizarDatosUsuario({ commit }, { dni, nombres }) {
    commit('SET_DNI', dni);
    commit('SET_NOMBRES', nombres);
    // Guardar en el almacenamiento local
    localStorage.setItem('userData', JSON.stringify({ dni, nombres }));
  },

  //Datos de la API de roles
  async actualizarDatosRol({ commit }, userRol) {
    //console.log('userRol:', userRol);
    try {
      commit('SET_USER_ROL', userRol);
      // Guardar en el almacenamiento local
      localStorage.setItem('userRolData', JSON.stringify(userRol));
    } catch (error) {
      console.error('Error al obtener el userRol de la API:', error);
    }
  }  
}



// WEBPACK FOOTER //
// ./src/store/actions.js